import styled from 'styled-components'

import { Container } from '~/components/global'

type FooterColumnProps = {
  flex?: string
}

export const FooterWrapper = styled.footer`
  background-color: ${(props) => props.theme.color.primary};
  padding: 50px 0 80px;
  color: ${(props) => props.theme.color.white.regular};

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    padding: 50px 0;
  }
`
export const Logo = styled.div`
  font-family: ${(props) => props.theme.font.extrabold};
  ${(props) => props.theme.font_size.regular};
  color: ${(props) => props.theme.color.white.regular};
  text-decoration: none;
  letter-spacing: 1px;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 9;
  text-decoration: none;
  outline: 0px;
`

export const CopyrightContainer = styled(Container)`
  position: relative;
  padding-top: 48px;
  display: flex;
  align-items: flex-end;
  ${(props) => props.theme.typography.text}
  @media (max-width: ${(props) => props.theme.screen.md}) {
    justify-content: center;
  }
`
export const FooterColumnContainer = styled(Container)`
  display: flex;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 32px;
  justify-content: start;
  flex-direction: row;

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    flex-direction: column;
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`
export const FooterColumn = styled.div<FooterColumnProps>`
  flex: ${(props) => (props.flex ? props.flex : 'inherit')} !important;
  min-width: 170px;

  span {
    ${(props) => props.theme.typography.button}
  }

  p {
    ${(props) => props.theme.typography.text}
    max-width: 700px;
  }

  ul {
    list-style: none;
    margin: 16px 0;
    padding: 0;
    color: ${(props) => props.theme.color.white.regular};

    &.normal {
      a {
        color: white;
        &:hover {
          text-decoration: underline;
        }
      }
      li {
        line-height: 11px;
      }
      li::before {
        padding-right: 4px;
        padding-top: 2px;
        content: '• ';
        color: ${(props) => props.theme.color.white.regular};
        opacity: 0.5;
        font-size: 24px;
      }
    }

    li {
      ${(props) => props.theme.typography.text}

      a {
        color: ${(props) => props.theme.color.white.regular};
        transition: opacity 0.3s ease-in-out 0s;
      }

      a:hover {
        color: ${(props) => props.theme.color.white.regular};
        opacity: 0.7;
      }

      svg {
        margin-right: 5px;
      }

      display: flex;
      align-items: center;
      margin-bottom: 12px;

      &.social-grid {
        margin-top: 25px;

        a {
          display: flex;
          text-decoration: none;
          padding: 0;
        }

        > a ~ a {
          margin-left: 5px;
        }

        @media (max-width: ${(props) => props.theme.screen.sm}) {
          margin-top: 35px;

          svg {
            width: 36px;
            height: 36px;
          }

          > a ~ a {
            margin-left: 12px;
          }
        }
      }
    }
  }
`
